import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { KeyboardService } from '@geneplanet/ngx-shop/src/lib/shared';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-bottom-offset',
  templateUrl: './bottom-offset.component.html',
  styleUrls: ['./bottom-offset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class BottomOffsetComponent {
  private readonly keyboardService = inject(KeyboardService);

  readonly type = input<string>();

  public keyboardActive$: BehaviorSubject<boolean>;

  constructor() {
    this.keyboardActive$ = this.keyboardService.keyboardActive$;
  }
}
